import React from 'react';
import DropdownGeneral from '../DropdownGeneral/DropdownGeneral';
import { DropdownLocationProps } from './DropdownLocation.type';

const DropdownLocation: React.FC<DropdownLocationProps> = ({
  defaultValue = 'all',
  onChange
}) => {
  return (
    <DropdownGeneral
      data-testid="dropdown-location"
      placeholder="Select Location"
      onChange={(v, option) => {
        if (onChange) onChange(v as 'all' | 'unknown', option);
      }}
      defaultValue={defaultValue}
      list={[
        {
          value: 'all',
          label: 'All Locations'
        },
        {
          value: 'unknown',
          label: 'Unknown Locations'
        }
      ]}
    />
  );
};

export default DropdownLocation;
